import axios from 'axios';
import { store } from '../../store'; // Import the Redux store
import { setlogoutPopup } from '../../reducers/counterSlice';
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});


axiosInstance.interceptors.request.use(
  (config) => {
    const state = store.getState(); // Get the current Redux state
    const token = state.counterSlice.loginDetails.jwt;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.log(error.response, 'error.response')
      // store.dispatch(setlogoutPopup(true));
      if (typeof window.showLogoutPopup === 'function') {
        window.showLogoutPopup();
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
